import { put, select, takeLeading } from 'redux-saga/effects';
import { controlActions } from './slice';
import { settingsActions } from 'reduxStore/settings/slice';
import { selectControlSyncInProgress } from 'reduxStore/settings/selectors';
import { Notification } from 'zComponents/atoms';

export function* triggerSync() {
	// Never ask the server for a second sync while the org's syncing flag says one is running.
	if (yield select(selectControlSyncInProgress)) {
		Notification('info', 'A Zezamii Lock sync is already running.');
		yield put(controlActions.triggerSyncSuccess());
		return;
	}
	const superFetchModule = yield import('library/helpers/superFetch');
	const superFetch = superFetchModule.default;
	try {
		const res = yield superFetch.post(`/controlServer/sync`);
		if (res.statusCode === 200) {
			yield put(settingsActions.loadOrgSettings());
			yield put(controlActions.triggerSyncSuccess());
		} else {
			throw new Error(res.error);
		}
	} catch (error) {
		Notification('error', error.message || 'Failed to trigger Zezamii Lock sync.');
		yield put(controlActions.triggerSyncError(error.message));
	}
}

export default function* controlSagas() {
	// takeLeading: a double click while the request is in flight is dropped, not sent again.
	yield takeLeading(controlActions.triggerSync, triggerSync);
}
